import * as React from 'react'
import { useState, useEffect } from 'react'
import { Container, ButtonWrap, PolicyLink, DeclineButton, FlexWrap, AcceptButton } from './atoms'
import { getCookie, setCookie } from '../../utils'

export const PrivacyPolicy = () => {
  const [isHide, setIsHide] = useState(true)

  useEffect(() => {
    let intervalId = 0
    const consentModeString = getCookie('consentMode')
    if (consentModeString.length <= 0) {
      setIsHide(false)
    } else {
      setIsHide(true)
      const consentMode = JSON.parse(consentModeString)
      intervalId = window.setInterval(() => {
        if (window?.gtag) {
          window.gtag('consent', 'update', consentMode)
          clearInterval(intervalId)
        }
      }, 200)
    }
    return () => clearInterval(intervalId)
  }, [])

  const handleClick = (accept: boolean) => {
    const consentMode = {
      ad_storage: accept ? 'granted' : 'denied',
      ad_user_data: accept ? 'granted' : 'denied',
      ad_personalization: accept ? 'granted' : 'denied',
      analytics_storage: accept ? 'granted' : 'denied',
    } as { [key in string]: 'granted' | 'denied' }
    window.gtag('consent', 'update', consentMode)
    setCookie('consentMode', JSON.stringify(consentMode), 365)
    setIsHide(true)
  }

  return isHide ? null : (
    <Container style={{ zIndex: 10000000000 }}>
      <FlexWrap>
        <div>
          <p>
            {
              "We use cookies to enhance your experience on our site and analyze how it's used. This helps us improve our service and tailor content to you. For details, see our "
            }
            <PolicyLink href='https://www.foxrenderfarm.com/privacy.html'>
              Cookie Policy & Privacy.
            </PolicyLink>
          </p>
          <p>
            {
              "Don't want tracking? No problem. We'll respect your choice with a single cookie that remembers your preference."
            }
          </p>
        </div>
        <ButtonWrap>
          <DeclineButton onClick={() => handleClick(false)}>Decline</DeclineButton>
          <AcceptButton onClick={() => handleClick(true)}>Accept</AcceptButton>
        </ButtonWrap>
      </FlexWrap>
    </Container>
  )
}
